<script lang="ts" setup>
import { sdDrawerProps } from './drawer'
import { drawerEmits, ElDrawer, ElScrollbar } from 'element-plus'

import { useVModel } from '@vueuse/core'

defineOptions({ name: 'SdDrawer' })

const props = defineProps(sdDrawerProps)
const emit  = defineEmits(drawerEmits)

const drawerVisible = useVModel(props, 'modelValue', emit)

</script>

<template>
    <ElDrawer
        v-model="drawerVisible"
        :title="props.title"
        :append-to-body="props.appendToBody"
        :lock-scroll="props.lockScroll"
        :before-close="props.beforeClose"
        :close-on-click-modal="props.closeOnClickModal"
        :close-on-press-escape="props.closeOnPressEscape"
        :open-delay="props.openDelay"
        :custom-class="`sd-drawer ${props.customClass}`"
        :destroy-on-close="props.destroyOnClose"
        :modal="props.modal"
        :direction="props.direction"
        :show-close="props.showClose"
        :size="props.size"
        :with-header="props.withHeader"
        :modal-class="props.modalClass"
        :z-index="props.zIndex"
        @open="$emit('open')"
        @opened="$emit('opened')"
        @close="$emit('close')"
        @closed="$emit('closed')"
    >
        <div v-if="props.bodyLockScroll" class="sd-drawer__body is-lock">
            <slot></slot>
        </div>
    
        <ElScrollbar v-else style="flex: 1;">
            <div class="sd-drawer__body">
                <slot></slot>
            </div>
        </ElScrollbar>

        <div v-if="$slots.footer" class="sd-drawer__foot">
            <slot name="footer"></slot>
        </div>
    </ElDrawer>
</template>
